<template>
  <div class="pricing-page">
    <!-- <div class="pricing-header">
      <h1 class="pricing-title">价格方案</h1>
      <p class="pricing-subtitle">选择适合您的套餐，开启智能化店铺运营之旅</p>
    </div> -->
    
    <Pricing 
      :vip-plans="vipPlans" 
      @download-plugin="handleDownloadPlugin" 
      @show-customer-service="showCustomerServiceModal" 
    />

    <!-- 客服微信弹窗 -->
    <el-dialog
      v-model="customerServiceVisible"
      title="客服微信"
      width="400px"
      :show-close="true"
      center
    >
      <div class="customer-service-content">
        <img 
          src="https://yootiao.top/jbp/img/wxqc.png" 
          alt="客服微信二维码" 
          class="customer-service-qr"
        />
        <p class="customer-service-text">请扫描二维码添加客服微信进行咨询</p>
        <p class="customer-service-wechat">微信号：jbp-customer-service</p>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { checkVersion, getShopPrices } from '../api/admin'
import Pricing from '../components/Pricing.vue'

const vipPlans = ref([])
const customerServiceVisible = ref(false)

function isMobile() {
  return /Android|webOS|iPhone|iPod|BlackBerry|iPad|Windows Phone/i.test(navigator.userAgent)
}

async function onDownloadClick() {
  if (isMobile()) {
    alert('请到电脑端下载插件');
    return;
  }
  try {
    const res = await checkVersion('0.0.0')
    if (res.code === 200 && res.data && res.data.downPath) {
      window.location.href = res.data.downPath
    } else {
      alert(res.message || '获取下载链接失败')
    }
  } catch (e) {
    alert('网络错误，获取下载链接失败')
  }
}

// 处理价格组件的下载插件事件
function handleDownloadPlugin(plan) {
  if (isMobile()) {
    alert('请到电脑端下载插件');
    return;
  }
  try {
    // 调用现有的下载方法
    onDownloadClick()
  } catch (e) {
    alert('下载失败，请稍后重试')
  }
}

// 显示客服微信弹窗
function showCustomerServiceModal() {
  customerServiceVisible.value = true
}

onMounted(async () => {
  document.title = '聚宝铺-价格方案'
  try {
    const res = await getShopPrices()
    if (res.code === 200 && res.data) {
      vipPlans.value = res.data
    }
  } catch (e) {
    console.error('获取VIP信息失败', e)
  }
})
</script>

<style scoped>
.pricing-page {
  min-height: 100vh;
  background: #f7faff;
  color: #222;
  font-family: 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  /* padding: 20px 0; */
}

.pricing-header {
  text-align: center;
  margin-bottom: 60px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
}

.pricing-title {
  font-size: 2.8rem;
  font-weight: bold;
  color: #2979ff;
  margin-bottom: 16px;
}

.pricing-subtitle {
  color: #666;
  font-size: 1.1rem;
  line-height: 1.6;
}

/* 客服微信弹窗样式 */
.customer-service-content {
  text-align: center;
  padding: 20px 0;
}

.customer-service-qr {
  width: 200px;
  height: 200px;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.customer-service-text {
  color: #666;
  font-size: 14px;
  margin-bottom: 8px;
}

.customer-service-wechat {
  color: #2979ff;
  font-weight: bold;
  font-size: 16px;
}

@media (max-width: 768px) {
  .pricing-page {
    padding: 20px 0;
  }
  
  .pricing-header {
    margin-bottom: 40px;
    padding: 0 16px;
  }
  
  .pricing-title {
    font-size: 2.2rem;
  }
  
  .pricing-subtitle {
    font-size: 1rem;
  }
}
</style> 